import type { RouteRecordRaw } from 'vue-router'

const jobRoutes: RouteRecordRaw[] = [
  {
    path: 'vacancies/view/:slug',
    name: 'VacancyPage',
    component: () => import('@/v2/pages/job/JobPageGate.vue'),
    meta: {
      layout: 'empty',
      requiresAuth: false,
      coreThemeMode: 'mode-light'
    }
  }
]

export default jobRoutes
